module.exports = __webpack_public_path__ + "static/attractions-07853d6666828d3e0ee469b08f9748b3.jpg";